<template>
    <div class="el-card  pd20 special">
        <!-- 返回 -->
        <div class="cancel-box">
            <el-button type="info" icon="el-icon-arrow-left"  @click="$router.go(-1)"  size="medium">返回商品列表</el-button>
        </div>
        <el-divider></el-divider>
        <!-- form -->
        <el-form  :model="form"  :rules="rules" ref="form" >
            <!-- 商品名称 -->
            <el-form-item label="商品名称" prop="name"  :label-width="formLabelWidth">
                <el-input v-model="form.name" placeholder="请输入商品名称"></el-input>
            </el-form-item>
            <!-- 商品概要 -->
            <el-form-item label="商品概要" prop="brief"  :label-width="formLabelWidth">
                <el-input  v-model="form.brief"  placeholder="请输入商品概要" ></el-input>
            </el-form-item>
            <!-- 商品分类 -->
            <el-form-item label="商品分类" prop="category_ids"  :label-width="formLabelWidth">
                <el-tag
                    class="tag-class"
                    v-for="(item,index) in chooseTagList"
                    :key="item.id"
                    closable
                    :disable-transitions="false"
                    effect="dark"
                    @close="handleTagClose(index,item)"
                    >
                    {{ item.name }}
                </el-tag>
                <template>
                    <el-button type="primary" size="small" plain @click="chooseClass()">选择分类</el-button>
                </template>
            </el-form-item>
            <!-- 测评基数 -->
            <el-form-item label="测评基数" prop="base_count"  :label-width="formLabelWidth">
                <el-input  v-model.number="form.base_count"  placeholder="请输入测评基数" ></el-input>
            </el-form-item>
            <!-- 商品状态 -->
            <el-form-item label="商品状态" prop="status" :label-width="formLabelWidth">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">上架</el-radio>
                    <el-radio :label="-1">下架</el-radio>
                </el-radio-group>
            </el-form-item>
             <!-- 付款类型 -->
            <el-form-item label="付款类型" prop="pay_type" :label-width="formLabelWidth">
                <el-radio-group v-model="form.pay_type">
                    <el-radio :label="0">现金+兑换</el-radio>
                    <el-radio :label="1">仅兑换</el-radio>
                </el-radio-group>
            </el-form-item>
            <!-- 商品类型 -->
            <el-form-item label="商品类型" prop="type" :label-width="formLabelWidth">
                <el-radio-group @change="productChange" v-model="form.type">
                    <el-radio :label="1">单个商品</el-radio>
                    <el-radio :label="2">套餐商品</el-radio>
                </el-radio-group>
            </el-form-item>
            <!--  -->
            <el-form-item prop="pay_config_id" label="付款账户" :label-width="formLabelWidth">
                <el-select v-model="form.pay_config_id" placeholder="请选择付款账户">
                <el-option v-for="(item,index) in payConfigList" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <!-- ------begin 单一商品展示 -->
            <!-- 测评ID -->
            <el-form-item v-if="form.type==1" label="测评ID" prop="cid"  :label-width="formLabelWidth">
                <el-input  v-model="form.cid"  placeholder="请输入测评ID"  ></el-input>
            </el-form-item>
            <!-- 答题链接 -->
            <el-form-item v-if="form.type==1" label="答题链接" prop="link"  :label-width="formLabelWidth">
                <el-input  v-model="form.link"  placeholder="请输入答题链接"  ></el-input>
            </el-form-item>
            <!------- end 单一商品展示----- -->
            <!-- begin 套餐商品 -->
            <el-form-item v-if="form.type==2"    label-width="50px">
                <child-list style="width:900px;" :relatedIds="form.related_ids" @relatedHandle="relatedHandle"></child-list>
            </el-form-item>
            <!-- end 套餐商品 -->
            <!--  -->
            <!-- 原价 -->
            <el-form-item label="原价（分）" prop="price"  :label-width="formLabelWidth">
                <el-input  v-model="form.price"  placeholder="请输入原价(不需要填写单位)"  ></el-input>
            </el-form-item>
            <!-- 优惠价格 -->
            <el-form-item label="优惠价格（分）" prop="discount_price"  :label-width="formLabelWidth">
                <el-input  v-model="form.discount_price"  placeholder="请输入优惠价格(不需要填写单位)"  ></el-input>
            </el-form-item>
            <!-- 优惠价格 -->
            <el-form-item label="内部价格（分）" prop="wholesale_price"  :label-width="formLabelWidth">
                <el-input  v-model="form.wholesale_price"  placeholder="请输入内部价格(不需要填写单位)"  ></el-input>
            </el-form-item>
            <!-- 高报师价格 -->
            <el-form-item label="高报师价格（分）" prop="gaobao_price"  :label-width="formLabelWidth">
                <el-input  v-model="form.gaobao_price"  placeholder="请输入高报师价格(不需要填写单位)"  ></el-input>
            </el-form-item>
            <!-- 高报师价格 -->
            <el-form-item label="高报师二阶价格（分）" prop="gaobao_pro_price"  :label-width="formLabelWidth">
                <el-input  v-model="form.gaobao_pro_price"  placeholder="请输入高报师二阶价格(不需要填写单位)"  ></el-input>
            </el-form-item>
            <!-- 学习力指导师价格 -->
            <el-form-item label="学习力指导师价格(分)" prop="xuexi_price"  :label-width="formLabelWidth">
                <el-input  v-model="form.xuexi_price"  placeholder="请输入学习力指导师价格(不需要填写单位)"  ></el-input>
            </el-form-item>
            
            <!-- 推广图 -->
            <el-form-item  label="推广图"  prop="image" :label-width="formLabelWidth">
                <el-upload
                    class="upload-demo"
                    :show-file-list="false"
                    :http-request="uploadImg"
                    :before-upload="beforeAvatarUpload">
                    <el-button size="small" @click="upload_type='product'" type="primary">上传封面（小于1MB）</el-button>
                </el-upload>
                <!--  -->
                <el-image class="up-image" :src="form.image">
                    <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                    </div>
                    <div slot="error" style="height:150px;line-height:150px;" class="image-slot error">
                        请上传图片...
                    </div>
                </el-image>
            </el-form-item>
            <!-- 亮点 -->
            <el-form-item label="亮点" prop="highlights" :label-width="formLabelWidth">
                <el-input type="textarea" v-model="form.highlights"  placeholder="请输入亮点"   :rows="4"></el-input>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item label="备注"  :label-width="formLabelWidth">
                <el-input type="textarea" v-model="form.remark"  placeholder="请输入备注"   :rows="4"></el-input>
            </el-form-item>
            <!-- 商品描述 -->
            <el-form-item label="商品描述"  prop="description"   :label-width="formLabelWidth">
                <vue-ueditor-wrap id="specoal_ue_box" v-model="form.description" :config="ueConfig" @ready="editorReady"></vue-ueditor-wrap>
            </el-form-item>
            <!-- 定制logo -->
            <el-form-item  label="定制logo"   :label-width="formLabelWidth">
                <el-upload
                    class="upload-demo"
                    :show-file-list="false"
                    :http-request="uploadImg"
                    :before-upload="beforeAvatarUpload">
                    <el-button size="small" @click="upload_type='logo_img'" type="primary">上传定制logo（小于1MB）</el-button>
                </el-upload>
                <!--  -->
                <el-image class="up-image" :src="form.logo_img">
                    <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                    </div>
                    <div slot="error" style="height:150px;line-height:150px;" class="image-slot error">
                        请上传图片...
                    </div>
                </el-image>
            </el-form-item>
            <!-- 定制报告 -->
            <el-form-item label="定制报告" :label-width="formLabelWidth">
                <el-radio-group v-model="form.is_custom">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <!--  -->
            <el-form-item  :label-width="formLabelWidth">
                <el-button type="primary" @click="submitForm('form')" >提交</el-button>
                <!-- <el-button  @click="previewHandle"  >{{preview_text}}</el-button> -->
            </el-form-item>
        </el-form>
        <!-- 预览 -->
        <!-- <preview-mobile :html="form.description" :isPreview="preview"></preview-mobile> -->
        <!-- 选择分类 -->
        <el-dialog title="选择分类" :visible.sync="chooseClassShow">
            <div class="list-box">
                <el-table border show-overflow-tooltip style="width: 100%" :data="chooseClassList">
                    <el-table-column prop="name" label="分类名称" ></el-table-column>
                    <el-table-column label="类型">
                        <template slot-scope="scope">
                            {{scope.row.type == 1?'大分类':'小分类'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="操作" width="180">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.tag"  type="info" size="small"  icon="el-icon-check" circle></el-button>
                            <el-button v-else type="primary" size="small" @click="checkTag(scope.$index, scope.row)" icon="el-icon-check" circle></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 分页 -->
            <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="chooseClassPages.size" 
                :current-page="chooseClassPages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="chooseClassPages.count"> 
            </el-pagination>
        </el-dialog>
    </div>
</template>

<script>
import { productCategoryList,addProduct,getProduct,updateProduct } from "@/api/measurement";
import { getPayConfigList } from "@/api/consultant";
import { upload_image} from "@/api/operating";
import VueUeditorWrap from "vue-ueditor-wrap";
import previewMobile from '@c/preview-mobile'
import ChildList from './components/child-list'
import { isMain, isDev } from "@u/tools";
export default {
    data() {
        return{
            formLabelWidth:'170px',
            list:[],
            preview:false,
            preview_text:'预 览',
            ueConfig: {
                // 编辑器不自动被内容撑高
                autoHeightEnabled: false,
                // 初始容器高度
                initialFrameHeight: 300,
                // 初始容器宽度
                initialFrameWidth: "100%", // isMain()  ? "/test/system/static/UEditor/" : "/static/UEditor/"
                // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                UEDITOR_HOME_URL: isDev() ? '/static/UEditor/' : (isMain()  ? "/main/system/static/UEditor/" : "/test/system/static/UEditor/")
            },
            form:{
                name:'',
                brief:'',
                category_ids:'',
                base_count:null,
                status:null,
                pay_type:null,
                type:null,
                related_ids:null,
                link:'',
                cid:null,
                price:null,
                discount_price:null,
                wholesale_price:null,
                gaobao_price:null,
                gaobao_pro_price:null,
                remark:'',
                image:'',
                is_custom:null,
                highlights:'',
                description:'',
                pay_config_id:0,
                logo_img:''
            },
            payConfigList:[],
            upload_type:'',
            // 选择分类
            chooseTagList:[],
            chooseClassPages: {},
            chooseClassList:[],
            chooseClassShow:false,
            //这是一个验证规则
            rules:{
                name: [{
                        required: true,//是否必填
                        message: '请输入名称',//错误提示信息
                        trigger: 'blur'//检验方式（blur为鼠标点击其他地方，）
                    }
                ],
                brief:[{
                    required: true,
                    message: '请输入概要',
                    trigger: 'blur'
                }],
                category_ids:[{
                    required: true,
                    message: '请选择分类',
                    trigger: 'blur'
                }],
                base_count:[{
                        required: true,//是否必填
                        message: '请输入基数',//错误提示信息
                        trigger: 'change'
                    }
                ],
                status:[{
                    required: true,
                    message: '请选择状态',
                    trigger: 'change'
                }],
                pay_config_id:[{
                    required: true,
                    message: '请选择付款账户',
                    trigger: 'change'
                }],
                pay_type:[{
                    required: true,
                    message: '请选择付款类型',
                    trigger: 'change'
                }],
                type: [{
                    required: true,//是否必填
                    message: '请选择类型',//错误提示信息
                    trigger: 'blur'
                }],
                related_ids: [{
                    required: false,//是否必填
                    message: '请选择关联测评',//错误提示信息
                    trigger: 'blur'
                }],
                link: [{
                    required: false,//是否必填
                    message: '请输入答题链接',//错误提示信息
                    trigger: 'blur'
                }],
                cid: [{
                    required: false,//是否必填
                    message: '请输入关联测评ID',//错误提示信息
                    trigger: 'blur'
                }],
                price: [{
                    required: true,//是否必填
                    message: '请输入原价',//错误提示信息
                    trigger: 'blur'
                }],
                discount_price: [{
                    required: true,//是否必填
                    message: '请输入优惠价',//错误提示信息
                    trigger: 'blur'
                }],
                wholesale_price: [{
                    required: true,//是否必填
                    message: '请输入内部价格',//错误提示信息
                    trigger: 'blur'
                }],
                gaobao_price: [{
                    required: true,//是否必填
                    message: '请输入高报师价格',//错误提示信息
                    trigger: 'blur'
                }],
                gaobao_pro_price: [{
                    required: true,//是否必填
                    message: '请输入高报师二阶价格',//错误提示信息
                    trigger: 'blur'
                }],
                xuexi_price: [{
                    required: true,//是否必填
                    message: '请输入学习力指导师价格',//错误提示信息
                    trigger: 'blur'
                }],
                image: [{
                    required: true,//是否必填
                    message: '请上传推广图',//错误提示信息
                    trigger: 'blur'
                }],
                highlights: [{
                    required: true,//是否必填
                    message: '请输入亮点',//错误提示信息
                    trigger: 'blur'
                }],
                description: [{
                    required: true,//是否必填
                    message: '请输入描述',//错误提示信息
                    trigger: 'blur'
                }]
            }
        }
    },
    components:{
        VueUeditorWrap,
        previewMobile,
        ChildList
    },
    methods:{
        /*
         *@param: ids 关联测评id
         *@Description: 接受关联测评id
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-12-11 10:43:45
        */
        relatedHandle(ids){
            this.form.related_ids = ids;
        },
        /*
         *@Description: 改变商品类型时触发
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-12-10 18:45:03
        */
        productChange(val){
            if(val==1){
                this.form.related_ids="";
            }
            if(val==2){
                this.form.cid="";
                this.form.link="";
            }
        },
        /*
         *@param: index 下标,item 行对象
         *@return: 
         *@Description: 删除标签
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-12-10 12:25:55
        */
        handleTagClose(index,item){
            let arr = this.form.category_ids.split(',');
            this.$delete(arr,index);
            this.form.category_ids = arr.join(',');
            this.$delete(this.chooseTagList,index);
            this.$delete(this.chooseClassList[item.index],'tag');
        },
        /*
         *@param: index 下标、row 行对象
         *@Description: 选择标签
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-12-10 11:48:44
        */
        checkTag(index,row){
            this.chooseClassList[index]['tag'] = row.id;
            this.chooseTagList.push({
                id:row.id,
                index:index,
                name:row.name
            });
            this.form.category_ids = (this.form.category_ids!='')?(this.form.category_ids+','+row.id):row.id;
            this.chooseClassShow = false;
        },
        // 调整每页显示条数
        handleSizeChange(val) {
            this.chooseClassPages.size = val;
            this.getChooseClass();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.chooseClassPages.page = val;
            this.getChooseClass();
        },
        /*
         *@param: 
         *@return: 
         *@Description: 选择分类
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-12-10 10:29:26
        */
        chooseClass(){
            this.chooseClassShow = true;
        },
        // 预览
        previewHandle(){
            this.preview = !this.preview;
            this.preview_text = this.preview?'收 起':'预 览';
        },
        // 提交数据
        save(){
            if(this.$route.query.id){
                updateProduct(this.form).then((data)=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return
                    }
                    this.$notify({
                        title: '成功',
                        message: '提交成功！',
                        type: 'success'
                    });
                });
            }else{
                addProduct(this.form).then((data)=>{
                    if(data.error >0){
                        this.$message(data.msg);
                        return
                    }
                    this.$notify({
                        title: '成功',
                        message: '提交成功！',
                        type: 'success'
                    });
                });
            }
            this.$router.go(-1);
            
        },
        //提交前验证
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    let f = this.form;
                    // 类型为单个商品时
                    if(f.type==1 && (!f.link || !f.cid)){
                        this.$message.warning('请输入测评id或答题链接！');
                        return false;
                    }
                    //类型为套餐商品时
                    if(f.type==2 && !f.related_ids){
                        this.$message.warning('请选择关联测评！');
                        return false;
                    }
                    this.save();
                } else {
                    this.$message.warning('请检查数据是否为空？');
                    return false;
                }
            });
        },
        // 上传图片前
        beforeAvatarUpload(file) {
            const isJPG = true;
            const isLt2M = file.size / 1024/ 1024  < 1;

            if (!file.type === 'image/jpg' || !file.type === 'image/png' || !file.type === 'image/gif' ) {
                isJPG = false;
                this.$message.error('上传头像图片只能是 jpg/png/gif 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 1MB!');
            }
            return isJPG && isLt2M;
        },
        // 上传图片
        uploadImg(param){
            // FormData 对象
            let form = new FormData();
            // 文件对象
            form.append("image", param.file);
            // 携带当前讲座的id
            form.append("key", this.$route.path+'?type='+this.upload_type);
            form.append("preserve", 1);

            // 上传图片接口
            upload_image(form).then((data)=>{
                if(this.upload_type === 'product'){
                    this.form.image = data.image_url;
                }
                if(this.upload_type === 'logo_img'){
                    this.form.logo_img = data.image_url;
                }

            });
        },
        /*
         *@Description: 初始化获取数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-12-10 11:30:20
        */
        pullData(){
            this.$showLoading();
            //获取商品分类
            let pType = productCategoryList({
                page:this.pages?this.pages.page:1,  //页码，默认1
                size:this.pages?this.pages.size:25,   //每页数量，默认25
            }).then((data)=>{
                this.chooseClassList = data.list;
                this.chooseClassPages = data.pager;
            })
            
            let arr = [pType];
            if(this.$route.query.id){
                // 获取数据
                let list = getProduct({
                    id:this.$route.query.id
                }).then((data)=>{
                    this.form = data.item;
                });
                arr.push(list);
            }
            Promise.all(arr).then(()=>{
              if(this.$route.query.id){
                this.chooseClassList.forEach((item, index) => {
                    if(this.form.category_ids && this.form.category_ids.split(",").includes(String(item.id))){
                        item["tag"] = item.id;
                        item["index"] = index;
                        this.chooseTagList.push(item);
                    }
                });
              }
              this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
            getPayConfigList().then(res=>{
                if(res.error >0){
                    this.$message(res.msg);
                    return
                }
                this.payConfigList = res.list;
            });
        },
        editorReady(ue) {
            ue.execCommand("serverparam",(editor)=>{
                return {
                key: this.$route.path+"?id="+this.$route.query.id
                };
            });
            console.log("ueditor准备就绪");
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
#specoal_ue_box{
    width: 800px;
    display: inline-block;
    line-height: 1;
  }
.special{
    .el-input,.el-textarea{
        width:775px;
    }
    .price{
        width: 600px;
    }
}

.tag-class{
    margin-right: 10px;
}
.cancel-box{
    margin-bottom: 20px;
}
.up-image{
    margin: 20px auto auto;
    width: 187.5px;
    text-align: center;
    border-radius: 8px;
    .error{
        border-radius: 8px;
        background-color: rgba($color: #eeeeee, $alpha: .5);
    }
}
.list-box{
    padding: 10px;
    background-color: #ffffff;
}
</style>
